export const isArray = Array.isArray || ((x) => x && typeof x.length === 'number');
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm2015/util/isArray.js
// module id = ./node_modules/rxjs/_esm2015/util/isArray.js
// module chunks = vendor